module.exports = __webpack_public_path__ + "img/gal-8.b34e15d9.jpg";